"use client";

import { RouteErrorBoundary } from "@/components/states/route-error";

/**
 * Error boundary for the authenticated app pages. Nested inside `(app)/layout`,
 * so the `AppShell` (header/nav/footer) stays put while this recovers just the
 * page body.
 */
export default function AppError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary {...props} source="boundary:(app)" />;
}
